import React from 'react';
import DataTable from 'react-data-table-component';
import { IconEdit, IconEye, IconTrash } from '@tabler/icons-react';
import { USER_SCOPE_CENTRAL } from './constants';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const DatatableCpanelUsers = ({
  scope,
  listUsers,
  search,
  handleChangeSearch,
  handleShowUser,
  handleEditUser,
  handleHapusUser,
}) => {
  const isCentral = scope === USER_SCOPE_CENTRAL;

  const actionCell = (row) => (
    <div className="cpanel-user-actions d-flex flex-nowrap align-items-center gap-1">
      <button className="btn btn-sm btn-outline-info" type="button" title="Detail" onClick={() => handleShowUser(row)}>
        <IconEye stroke={2} />
      </button>
      <button className="btn btn-sm btn-outline-warning" type="button" title="Edit" onClick={() => handleEditUser(row)}>
        <IconEdit stroke={2} />
      </button>
      <button className="btn btn-sm btn-outline-danger" type="button" title="Hapus" onClick={() => handleHapusUser(row)}>
        <IconTrash stroke={2} />
      </button>
    </div>
  );

  const actionColumn = {
    name: 'Aksi',
    width: '200px',
    minWidth: '200px',
    allowOverflow: false,
    style: { paddingRight: '1.5rem' },
    headStyle: { paddingRight: '1.5rem' },
    cell: actionCell,
  };

  const centralColumns = [
    actionColumn,
    {
      name: 'Username',
      minWidth: '160px',
      width: '160px',
      style: { paddingLeft: '1rem' },
      headStyle: { paddingLeft: '1rem' },
      selector: (row) => row.username || '',
      sortable: true,
    },
    {
      name: 'Nama Lengkap',
      minWidth: '180px',
      selector: (row) => row.namaLengkap || row.fullName || '',
      sortable: true,
    },
    { name: 'Email', minWidth: '180px', selector: (row) => row.email || '-', sortable: true },
    { name: 'Role', minWidth: '120px', selector: (row) => row.role || '-', sortable: true },
    { name: 'Status', width: '100px', selector: (row) => row.active || 'YES' },
    {
      name: 'Dibuat',
      minWidth: '160px',
      selector: (row) => row.createdAt || row.created_at || '',
      cell: (row) => formatDate(row.createdAt || row.created_at),
    },
  ];

  const hospitalColumns = [
    actionColumn,
    {
      name: 'Tenant',
      minWidth: '180px',
      width: '180px',
      style: { paddingLeft: '1rem' },
      headStyle: { paddingLeft: '1rem' },
      selector: (row) => row.tenantSlug || '',
      sortable: true,
      cell: (row) =>
        row.tenantSlug ? (
          <a href={`/hospitals/${row.tenantSlug}/users`} target="_blank" rel="noreferrer">
            {row.tenantSlug}
          </a>
        ) : (
          '-'
        ),
    },
    {
      name: 'Nama Lengkap',
      minWidth: '220px',
      selector: (row) => row.namaLengkap || '',
      sortable: true,
    },
    {
      name: 'Group',
      minWidth: '150px',
      selector: (row) => row.groupName || row.role || '',
      sortable: true,
    },
    {
      name: 'Active',
      minWidth: '100px',
      cell: (row) =>
        row.active === 'YES' ? (
          <span className="badge bg-success">YES</span>
        ) : (
          <span className="badge bg-danger">NO</span>
        ),
    },
  ];

  const columns = isCentral ? centralColumns : hospitalColumns;

  return (
    <>
      {!isCentral ? <h5 className="card-title mb-3">Daftar Pengguna</h5> : null}
      <input
        type="search"
        className="form-control form-control-sm cpanel-tenants-search mb-3"
        placeholder={
          isCentral ? 'Cari username, nama, email...' : 'Cari nama lengkap, username, tenant, group...'
        }
        value={search}
        onChange={(e) => handleChangeSearch(e.target.value)}
      />
      <DataTable
        className="cpanel-users-datatable"
        columns={columns}
        data={listUsers}
        pagination
        highlightOnHover
        noDataComponent={<div className="py-5 text-muted">Belum ada data pengguna.</div>}
      />
    </>
  );
};

export default DatatableCpanelUsers;
